// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as InfoBlock from "../../resources/layout-and-structure/InfoBlock.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderInformationCard(props) {
  let updatedAt = props.updatedAt;
  let receptionFinishedAt = props.receptionFinishedAt;
  let editable = props.editable;
  let state = OrderEditForm.useFormState();
  let dispatch = OrderEditForm.useFormDispatch();
  let scope = Auth.useScope();
  let shops = Auth.useShops();
  let renderSelectedShop = () => {
    let shop = shops.find(shop => shop.id === state.values.shopId);
    if (shop !== undefined) {
      return JsxRuntime.jsxs(InlineText.make, {
        children: [
          JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("By") + " ",
            variation: "normal"
          }),
          JsxRuntime.jsx(TextStyle.make, {
            children: shop.name,
            weight: "strong"
          })
        ]
      });
    } else {
      return null;
    }
  };
  React.useEffect(() => {
    if (state.values.shopId !== state.initialValues.shopId) {
      let maybeShop = shops.find(shop => shop.id === state.values.shopId);
      if (state.values.supplierId !== "") {
        dispatch({
          TAG: "FieldValueChanged",
          _0: "SupplierId",
          _1: param => ""
        });
      }
      if (state.values.cart.products.length !== 0) {
        dispatch({
          TAG: "FieldValueChanged",
          _0: "Cart",
          _1: param => state.initialValues.cart
        });
      }
      if (maybeShop !== undefined) {
        let activeWebDeviceId = maybeShop.activeWebDeviceId;
        dispatch({
          TAG: "FieldValueChanged",
          _0: "DeviceId",
          _1: param => activeWebDeviceId
        });
      }
    }
  }, [state.values.shopId]);
  let tmp;
  if (editable) {
    let match = state.id;
    let tmp$1;
    if (scope.TAG === "Organisation" && match === undefined) {
      let items = shops.map(shop => ({
        TAG: "Option",
        key: shop.id,
        label: shop.name,
        value: shop.id
      }));
      tmp$1 = JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(OrderEditForm.InputSelect.make, {
            field: "ShopId",
            label: I18n.t("Shop"),
            placeholder: I18n.t("Select a shop"),
            sections: [{
                items: items
              }]
          }),
          JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(Banner.make, {
              textStatus: {
                TAG: "Warning",
                _0: I18n.t("Beware ! Once the draft is saved, you will no longer be able to edit the shop.")
              },
              compact: false
            }),
            spaceTop: "small"
          })
        ],
        space: "small"
      });
    } else {
      tmp$1 = renderSelectedShop();
    }
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(OrderEditForm.InputDate.make, {
          label: I18n.t("Issuing date"),
          field: "IssueDate"
        }),
        tmp$1
      ],
      space: "large"
    });
  } else {
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsxs(InlineText.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Issued on") + " ",
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, state.values.issueDate)
            })
          ]
        }),
        renderSelectedShop(),
        JsxRuntime.jsxs(Inline.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Last modif. on") + " ",
              variation: "normal"
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: updatedAt !== undefined ? I18n.template(I18n.t("{{date}} to {{time}}"), {
                  date: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, updatedAt),
                  time: I18n.dateTimeFormat(undefined, undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, updatedAt)
                }, undefined) : I18n.t("No registration")
            })
          ],
          space: "none"
        })
      ],
      space: "xsmall"
    });
  }
  let shop = shops.find(shop => shop.id === state.values.shopId);
  let tmp$2;
  if (shop !== undefined) {
    let legalRepresentative = shop.legalRepresentative;
    tmp$2 = JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsxs(InfoBlock.make, {
          children: [
            legalRepresentative !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                children: legalRepresentative
              }) : null,
            JsxRuntime.jsx(TextStyle.make, {
              children: shop.email
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: shop.phoneNumber
            })
          ],
          title: I18n.t("CONTACT")
        }),
        JsxRuntime.jsxs(InfoBlock.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: shop.name
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: shop.address
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: shop.postalCode + shop.city
            }),
            JsxRuntime.jsx(TextStyle.make, {
              children: shop.country
            })
          ],
          title: I18n.t("ADDRESS")
        })
      ],
      space: "xlarge"
    });
  } else {
    tmp$2 = null;
  }
  return JsxRuntime.jsxs(Card.make, {
    children: [
      JsxRuntime.jsx(JsxRuntime.Fragment, {
        children: tmp
      }),
      tmp$2,
      JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal",
        spacing: "xs"
      }),
      editable ? JsxRuntime.jsx(OrderEditForm.InputDate.make, {
          label: I18n.t("Estimated date of reception"),
          field: "EstimatedReceptionDate"
        }) : JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsxs(InlineText.make, {
              children: [
                JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Reception scheduled on") + " ",
                  variation: "normal"
                }),
                JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, state.values.estimatedReceptionDate)
                })
              ]
            }),
            receptionFinishedAt !== undefined ? JsxRuntime.jsxs(InlineText.make, {
                children: [
                  JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.t("Reception completed on") + " ",
                    variation: "normal"
                  }),
                  JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, receptionFinishedAt)
                  })
                ]
              }) : null
          ]
        })
    ],
    title: I18n.t("Orders information")
  });
}

let make = React.memo(OrderInformationCard);

export {
  make,
}
/* make Not a pure module */
